module.exports = __webpack_public_path__ + "static/media/chicken-crispy.47696d90.png";